module.exports = __webpack_public_path__ + "static/img/A.12d7eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/A.png
// module id = aUUS
// module chunks = 0